export const getPageSizeOpts = (baseNumber: number) => {
  const multipliers = [1, 2, 5, 10];

  return multipliers.map((multiplier) => ({
    label: String(baseNumber * multiplier),
    value: baseNumber * multiplier,
  }));
};
